import PropTypes from "prop-types";
import { useState } from "react";
import MasterFoodLibraryHeader from "./components/MasterFoodLibraryHeader";
import MasterFoodLibraryTable from "./components/MasterFoodLibraryTable";
import MasterMealsLibraryTable from "./components/MasterMealsLibraryTable";

const MasterFoodLibrary = ({ locals }) => {
  const { foodsByCoach, mealsByCoach } = locals;
  const initialState = {
    section: "food",
    search: "",
  };
  const [state, setState] = useState(initialState);

  const { section, search } = state;

  const filteredFoods = foodsByCoach.filter(({ name }) =>
    name.toLowerCase().includes(search.toLowerCase())
  );

  const filteredMeals = mealsByCoach.filter(({ name }) =>
    name.toLowerCase().includes(search.toLowerCase())
  );

  /**
   * Function to update the states
   * @param {*} newState
   * @returns
   */
  const updateState = (newState) =>
    setState((prevState) => ({ ...prevState, ...newState }));

  return (
    <main className="main-master-food-library">
      <MasterFoodLibraryHeader
        section={section}
        updateState={updateState}
        search={search}
      />
      {section === "food" ? (
        <MasterFoodLibraryTable data={filteredFoods} />
      ) : (
        <MasterMealsLibraryTable data={filteredMeals} />
      )}
    </main>
  );
};

MasterFoodLibrary.propTypes = {
  locals: PropTypes.object,
};

export default MasterFoodLibrary;
